export class ReferenceDataConstants {
  public static readonly CURRENT_APPLICATION_VERSION = 'CurrentApplicationVersion';
  public static readonly BROKER_INTERFACE_TYPE_ID = 2;
  public static readonly BRANCH_INTERFACE_TYPE_ID = 3;
  public static readonly DIRECT_INTERFACE_TYPE_ID = 4;

  public static readonly DEFAULT_CASE_SEARCH_CATEGORY_OPTION = 'CaseID';
  public static readonly DEFAULT_CASE_SORT_OPTION = 'LastModifiedDate';
  public static readonly DESC_SORT_DIRECTION = 'desc';
  public static readonly DEFAULT_TASK_SORT_OPTION = 'PublishedDate';
  public static readonly ASC_SORT_DIRECTION = 'asc';

  public static readonly FirstStartLoanGroupType = 'FST';
  public static readonly HelpToBuyLoanGroupType = 'RSH';
  public static readonly NICHALoanGroupType = 'NCH';
  public static readonly FamilyLinkLoanGroupType = 'RSFL';
  public static readonly RetirementLinkLoanGroupType = 'RSPN';
  public static readonly BuyToLetAffordabilityLoanGroupType = 'BA';

  public static readonly ERROR_MESSAGE_NAME = 'ErrorMessage';
  public static readonly ERROR_MESSAGE_ME000 = 'ME000';
  public static readonly ERROR_MESSAGE_EQ000 = 'EQ000';
  public static readonly ERROR_MESSAGE_SE000 = 'SE000';
  public static readonly ERROR_MESSAGE_SE001 = 'SE001';
  public static readonly ERROR_MESSAGE_AE000 = 'AE000';
  public static readonly ERROR_MESSAGE_DE000 = 'DE000';
  public static readonly ERROR_MESSAGE_USER_ACCOUNT = 'UserAccount';
  public static readonly ERROR_MESSAGE_STAFF_ACCOUNT = 'StaffAccount';
  public static readonly ERROR_MESSAGE_UI = 'UI';
  public static readonly ERROR_MESSAGE_ID = 12;
  public static readonly ERROR_MESSAGE_INVALID_DISTRIBUTED_DOCUMENT_FILE_SIZE = 'InvalidDistributedDocumentFileSize';
  public static readonly ERROR_MESSAGE_FILE_NAME = 'FileName';

  public static readonly FosteringAndMaintenanceIncomeEnabled = 'FosteringAndMaintenanceIncomeEnabled';
  public static readonly RetirementIncomeYears = 'RetirementIncomeYears';

  public static readonly CaseHubLoanAmount = 'CaseHubLoanAmount';
  public static readonly CaseHubLTV = 'CaseHubLTV';
  public static readonly CountryExcludeFromApplicantIncomeOptionsAttributeName = 'ExcludeFromApplicantIncomeOptions';
  public static readonly ClientEnvironmentAllowPhones = 'AllowPhones';
  public static readonly ClientEnvironmentAllowTablets = 'AllowTablets';
  public static readonly ClientEnvironmentDirectDebitGuaranteePdfUrl = 'DirectDebitGuaranteePdfUrl';
  public static readonly ClientEnvironmentDisableStartAdviceJourney = 'DisableStartAdviceJourney';
  public static readonly ClientEnvironmentFirstStart = 'FirstStartAvailable';
  public static readonly ClientEnvironmentEmailOfferAvailable = 'EMAIL_OFFER_AVAILABLE';
  public static readonly ClientEnvironmentMobileMinimumResolution = 'MobileMinimumResolution';
  public static readonly ClientEnvironmentOnlineOfferSingleAcceptance = 'OnlineOfferSingleAcceptance';
  public static readonly ClientEnvironmentOnlinePaymentUrl = 'OnlinePaymentUrl';
  public static readonly ClientEnvironmentOfferInvestmentPropertyLoanPdfUrl = 'OfferInvestmentPropertyLoanPdfUrl';
  public static readonly ClientEnvironmentSendSmsCooldownTimeInSeconds = 'SendSmsCooldownTimeInSeconds';
  public static readonly ClientEnvironmentAdviceEnabled = 'AdviceEnabled';
  public static readonly ReadInsurance = 'DeclarationEnableDeclarationAndConsentReadInsuranceDeclaration';
  public static readonly ConsentSection = 'DeclarationEnableDeclarationAndConsentSection';
  public static readonly AuthorityToComplete = 'DeclarationEnableIntroducerDeclarationAuthorityToComplete';
  public static readonly IdentityVerification = 'DeclarationEnableIntroducerDeclarationIdentityVerification';
  public static readonly IntroducerDeclarationSection = 'DeclarationEnableIntroducerDeclarationSection';
  public static readonly MarketingEmail = 'DeclarationEnableMarketingPreferenceEmail';
  public static readonly MarketingSection = 'DeclarationEnableMarketingPreferenceSection';
  public static readonly MarketingTel = 'DeclarationEnableMarketingPreferenceTelephone';
  public static readonly MarketingSMS = 'DeclarationEnableMarketingPreferenceSms';
  public static readonly MarketingPost = 'DeclarationEnableMarketingPreferencePost';
  public static readonly BrandMarketingSection = 'DeclarationEnableBrandMarketingPreferenceSection';
  public static readonly BrandMarketingEmail = 'DeclarationEnableBrandMarketingPreferenceEmail';
  public static readonly BrandMarketingTel = 'DeclarationEnableBrandMarketingPreferenceTelephone';
  public static readonly BrandMarketingSMS = 'DeclarationEnableBrandMarketingPreferenceSms';
  public static readonly BrandMarketingPost = 'DeclarationEnableBrandMarketingPreferencePost';
  public static readonly DataRangePreSelectedOption = 'DateCreated';
  public static readonly CaseOwner = 'CaseOwner';
  public static readonly AdhocTask = 'AdHoc';

  public static readonly ProductStatusProposed = 'P';
  public static readonly ProductStatusActive = 'A';
  public static readonly ProductStatusClosed = 'C';
  public static readonly ProductStatusWithdrawn = 'W';
  public static readonly ProductStatusSuperseded = 'S';

  public static readonly ExclusiveProductCore = 'Core';
  public static readonly ExclusiveProductExclusive = 'Exclusive';
  public static readonly CaseSearchCriteriaIntermediaryEmail = 'IntermediaryEmail';
  public static readonly CaseSearchCriteriaDirectUserEmail = 'DirectUserEmail';

  public static readonly AllowedFileExtensions = 'AllowedFileExtensions';
  public static readonly MaximumFileSizeInMegabytes = 'MaximumFileSizeInMegabytes';
  public static readonly ImportProductsAllowedFileExtensions = 'ImportProductsAllowedFileExtensions';

  public static readonly MainMenuSelect = 'select';
  public static readonly SecurityQuestionCount = 'SecurityQuestionCount';
  public static readonly AcceptedAnswer = 'acceptedanswer';
  public static readonly BuyToLetDynamicSectionOneEnd = 'BuyToLetDynamicSectionOneEnd';
  public static readonly DirectUserChangeStatusActionSuspend = 'Suspend';
  public static readonly DirectUserChangeStatusActionUnsuspend = 'Unsuspend';
  public static readonly DirectUserChangeStatusActionUnlock = 'Unlock';
  public static readonly NumberOfRecentTransactionsDisplayedOnAccountSummary =
    'NumberOfRecentTransactionsDisplayedOnAccountSummary';

  public static readonly TransactCheckStatusCodeFail = 'Fail';
  public static readonly TransactCheckStatusCodePass = 'Pass';

  public static readonly AffordabilityCalculatorUrl = 'AffordabilityCalculatorUrl';

  public static readonly SuitabilityReportCategoriesAffordability = 'Affordability';
  public static readonly SuitabilityReportCategoriesRecommendation = 'NegativeRecommendationCategory';
  public static readonly SuitabilityReportCategoriesRepaymentType = 'RepaymentType';
  public static readonly SuitabilityReportCategoriesProductType = 'ProductType';
  public static readonly SuitabilityReportCategoriesProposedTerm = 'ProposedTerm';
  public static readonly SuitabilityReportCategoriesAdditionalBorrowing = 'AdditionalBorrowing';

  public static readonly AdditionalBorrowingDebtConsolidation = 'DebtConsolidation';
  public static readonly AdditionalBorrowingOtherRemortgage = 'OtherRemortgage';

  public static readonly PrivateUserSessionDurationInMinutes = 'PrivateUserSessionDurationInMinutes';
  public static readonly PrivateUserSessionAboutToExpireDeltaInMinutes =
    'PrivateUserSessionAboutToExpireDeltaInMinutes';

  public static readonly ExternalUserSessionDurationInMinutes = 'UserSessionDurationInMinutes';
  public static readonly ExternalUserSessionAboutToExpireDeltaInMinutes = 'UserSessionAboutToExpireDeltaInMinutes';

  public static readonly MessageNotificationRefreshRate = 'MessageNotificationRefreshRate';

  public static readonly RecaptchaSiteKey = 'RecaptchaSiteKey';
  public static readonly AllowRecaptcha = 'AllowRecaptcha';
  public static readonly RecaptchaWidgetUrl = 'RecaptchaWidgetUrl';

  public static readonly DDMEmailSentTypeCode = 'DDMEmailSent';
  public static readonly DDMEmailFailedTypeCode = 'DDMEmailFailed';

  public static readonly BTLAffordabilityCalculatorUrl = 'BTLAffordabilityCalculatorUrl';

  public static readonly FIELD_ATTRIBUTE_NAME = 'field';
  public static readonly DIRECTION_ATTRIBUTE_NAME = 'direction';

  public static readonly PackagingAllApplicantsFilter = 'ALL';

  public static readonly UIErrorsOutput = 'UIErrorsOutput';
  public static readonly UIErrorsOutputNone = 'None';
  public static readonly UIErrorsOutputConsole = 'Console';
  public static readonly UIErrorsOutputNotification = 'Notification';

  public static readonly WorldpayRedirect = 'WorldpayRedirect';
  public static readonly DirectCustomerBuyToLetAllowed = 'DirectCustomerBuyToLetAllowed';

  public static readonly UICustomizationResourcesRelativePath = 'ResourcesRelativePath';

  public static readonly AipCertificate = 'AipCertificate';

  public static readonly DisplayCookiesDisclaimer = 'DisplayCookiesDisclaimer';

  public static readonly ResidentialStepOneDynamicSectionTwoEnd = 'ResidentialStepOneDynamicSectionTwoEnd';
  public static readonly ResidentialStepOneDynamicSectionOneEnd = 'ResidentialStepOneDynamicSectionOneEnd';
  public static readonly ResidentialStepTwoDynamicSectionOneEnd = 'ResidentialStepTwoDynamicSectionOneEnd';

  public static readonly OfferSessionDurationInMinutes = 'OfferSessionDurationInMinutes';
  public static readonly OfferSessionAboutToExpireDeltaInMinutes = 'OfferSessionAboutToExpireDeltaInMinutes';

  public static readonly PhoneContextBlacklistBrowserAttribute = 'Browser';
  public static readonly PhoneContextBlacklistOSAttribute = 'OS';

  public static readonly DisplayCookieLink = 'DisplayCookieLink';
  public static readonly DirectCustomerResidentialAllowed = 'DirectCustomerResidentialAllowed';

  public static readonly ChangePaymentDetailsMiniForm = 'ChangePaymentDetailsMiniForm';
  public static readonly ManageCustomerAccountMiniForm = 'ManageCustomerAccountMiniForm';
  public static readonly ChangeCustomerDetailsMiniForm = 'ChangeCustomerDetailsMiniForm';

  public static readonly NeedAdviceShowBranchSection = 'NeedAdviceShowBranchSection';
  public static readonly NeedAdviceShowContactUsSection = 'NeedAdviceShowContactUsSection';
  public static readonly NeedAdviceShowRequestCallbackSection = 'NeedAdviceShowRequestCallbackSection';

  public static readonly HelpCenterShowRequestCallbackSection = 'HelpCenterShowRequestCallbackSection';

  public static readonly ChangeSamId = 'ChangeSamId';

  public static readonly SOFDetailsCharsLimit = 'SOFDetailsCharsLimit';

  public static readonly PasswordStrengthLevel1 = 'LEVEL1';
  public static readonly PasswordStrengthLevel2 = 'LEVEL2';
  public static readonly PasswordStrengthLevel3 = 'LEVEL3';
  public static readonly PasswordStrengthLevel4 = 'LEVEL4';
  public static readonly PasswordSpecialCharacters = 'PasswordSpecialCharacters';
  public static readonly AllowPasswordStrengthValidation = 'AllowPasswordStrengthValidation';

  public static readonly ContactNumberLength = 'ContactNumberLength';
  public static readonly ContactNumberStartingDigits = 'ContactNumberStartingDigits';

  public static readonly OfferPlaceholderEmailAddress = 'OfferPlaceholderEmailAddress';
  public static readonly OfferPlaceholderPhoneNumber = 'OfferPlaceholderPhoneNumber';

  public static readonly OnlineOfferLoginButtonLink = 'OnlineOfferLoginButtonLink';

  public static readonly ShowImportantMessageIllustrationOverview = 'ShowImportantMessageIllustrationOverview';

  public static readonly EpcRatingContactAdviserInfo = 'EpcRatingContactAdviserInfo';
  public static readonly EPCDateIssuedMaxAge = 'EPCDateIssuedMaxAge';

  public static readonly DynamicContentPlaceholderPrefix = '__ROME__';

  public static readonly PropertyUnderConstruction = '1';

  public static readonly PartRedemptionMaxDelta = 'PartRedemptionMaxDelta';
  public static readonly PartRedemptionMinAmount = 'PartRedemptionMinAmount';

  public static readonly RequestOverpaymentTermReduction = 'RequestOverpaymentTermReduction';
}
